import {NormalizedPackingSlipDefaultTemplate} from 'src/interfaces/packingSlipTemplateMappers'

export const REFERENCE_B2B_PACKING_SLIP_STARTER: NormalizedPackingSlipDefaultTemplate = {
  id: 'built-in-b2b-packing-list',
  label: 'B2B packing list (Letter)',
  isDefault: true,
  html: `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <style>
    html, body {
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
      min-height: 100%;
      font-family: Arial, sans-serif;
      font-size: 11px;
      line-height: 1.4;
      color: #000;
      background: #fff;
    }

    .packing-list {
      width: 100%;
      height: 100%;
      min-height: 100%;
      padding: 0.4in;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .packing-list__header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 24px;
      padding-bottom: 10px;
      border-bottom: 2px solid #000;
    }

    .packing-list__brand,
    .packing-list__title {
      display: flex;
      flex-direction: column;
    }

    .packing-list__brand {
      gap: 5px;
    }

    .packing-list__title {
      align-items: flex-end;
      flex-shrink: 0;
      gap: 2px;
      text-align: right;
    }

    .packing-list__title h1 {
      margin: 0;
      font-size: 26px;
      line-height: 1;
      letter-spacing: 0.04em;
    }

    .packing-list__logo {
      display: block;
      max-width: 150px;
      max-height: 40px;
      object-fit: contain;
      object-position: left center;
    }

    .packing-list__logo-placeholder {
      display: none;
      width: 150px;
      height: 38px;
      border: 1px dashed #9ca3af;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;
      color: #6b7280;
      font-size: 10px;
    }

    .packing-list__grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 12px;
    }

    .packing-list__box {
      min-width: 0;
      min-height: 54px;
      padding: 7px 9px;
      border: 1px solid #000;
      box-sizing: border-box;
      overflow-wrap: anywhere;
    }

    .packing-list__addresses .packing-list__box {
      min-height: 92px;
    }

    .packing-list__value--multiline::after {
      white-space: pre-line;
    }

    .packing-list__table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
    }

    .packing-list__table th,
    .packing-list__table td {
      padding: 6px 7px;
      border: 1px solid #000;
      text-align: left;
      vertical-align: top;
      overflow-wrap: anywhere;
    }

    .packing-list__table th {
      background: #eee;
      font-weight: 700;
    }

    .packing-list__table .packing-list__number {
      text-align: left;
    }

    .mc-packing-slip-preview-only {
      display: none;
    }

    .packing-list__carrier {
      margin: 2px 0 0;
    }

    .packing-list__barcode {
      display: none;
      width: 190px;
    }

    .packing-list__barcode-bars {
      width: 190px;
      height: 50px;
      background: repeating-linear-gradient(
        90deg,
        #000 0 2px,
        #fff 2px 4px,
        #000 4px 5px,
        #fff 5px 8px,
        #000 8px 11px,
        #fff 11px 13px
      );
    }

    .packing-list__barcode-label {
      display: block;
      margin-top: 3px;
      font-size: 10px;
      letter-spacing: 0.22em;
      text-align: center;
    }

    .packing-list__footer {
      margin-top: auto;
      padding-top: 24px;
    }
  </style>
</head>
<body>
  <main class="packing-list">
    <header class="packing-list__header">
      <div class="packing-list__brand" data-mc-preview-logo>
        <img class="packing-list__logo mc-packing-slip-liquid" alt="{{ store.name }}">
        <div class="packing-list__logo-placeholder mc-packing-slip-preview-only">ACME OUTDOOR CO.</div>
        <div data-mc-preview="1450 Commerce Dr, Columbus, OH 43215 · (614) 555-0188">
          <span class="mc-packing-slip-liquid">{{ store.address }} · {{ store.phone }}</span>
        </div>
      </div>
      <div class="packing-list__title">
        <h1>PACKING LIST</h1>
        <div>
          Vendor #: <b data-mc-preview="VND-20931"><span class="mc-packing-slip-liquid">{{ customer.vendor_id }}</span></b>
        </div>
      </div>
    </header>

    <section class="packing-list__grid">
      <div class="packing-list__box">
        <b>PO Number</b><br>
        <span data-mc-preview="PO-4471-B"><span class="mc-packing-slip-liquid">{{ order.po_number }}</span></span>
      </div>
      <div class="packing-list__box">
        <b>Order #</b><br>
        <span data-mc-preview="ORD-88912"><span class="mc-packing-slip-liquid">{{ order.number }}</span></span>
      </div>
      <div class="packing-list__box">
        <b>Ship Date</b><br>
        <span data-mc-preview="08/07/2026"><span class="mc-packing-slip-liquid">{{ shipment.ship_date | date: "%m/%d/%Y" }}</span></span>
      </div>
    </section>

    <section class="packing-list__grid packing-list__addresses">
      <div class="packing-list__box">
        <b>SHIP TO</b><br>
        <div class="packing-list__value--multiline" data-mc-preview="Northwind Retail DC #14&#10;4200 Distribution Way&#10;Joliet, IL 60436"><span class="mc-packing-slip-liquid">{{ shipping.full }}</span></div>
      </div>
      <div class="packing-list__box">
        <b>BILL TO</b><br>
        <div class="packing-list__value--multiline" data-mc-preview="Northwind Retail Inc.&#10;Accounts Payable, 100 Main St&#10;Chicago, IL 60601"><span class="mc-packing-slip-liquid">{{ billing.full }}</span></div>
      </div>
      <div class="packing-list__box">
        <b>SHIP FROM</b><br>
        <div class="packing-list__value--multiline" data-mc-preview="Acme Logistics&#10;Bay 12, Industrial Pkwy&#10;Columbus, OH 43215"></div>
      </div>
    </section>

    <table class="packing-list__table">
      <colgroup>
        <col style="width: 5%">
        <col style="width: 13%">
        <col style="width: 16%">
        <col style="width: 15%">
        <col>
        <col style="width: 8%">
        <col style="width: 8%">
      </colgroup>
      <thead>
        <tr>
          <th>Line</th>
          <th>Buyer SKU</th>
          <th>Vendor SKU</th>
          <th>UPC</th>
          <th>Description</th>
          <th>Ord.</th>
          <th>Ship.</th>
        </tr>
      </thead>
      <tbody>
        <!-- {% for item in order.items %} -->
        <tr>
          <td data-mc-preview="1"></td>
          <td data-mc-preview="NW-448120"></td>
          <td data-mc-preview="HK-BP-30L-BLU"></td>
          <td data-mc-preview="084512330192"></td>
          <td data-mc-preview="Hiking Backpack 30L – Blue"><span class="mc-packing-slip-liquid">{{ item.name }}</span></td>
          <td data-mc-preview="24"></td>
          <td data-mc-preview="24"></td>
        </tr>
        <!-- {% endfor %} -->
        <tr class="mc-packing-slip-preview-only">
          <td>2</td><td>NW-448121</td><td>WB-SST-750-BLK</td><td>084512330277</td>
          <td>Steel Water Bottle 750 ml – Black</td><td>48</td><td>48</td>
        </tr>
        <tr class="mc-packing-slip-preview-only">
          <td>3</td><td>NW-448133</td><td>TN-2P-GRN</td><td>084512330413</td>
          <td>Camp Tent 2-Person – Green</td><td>6</td><td>6</td>
        </tr>
      </tbody>
    </table>

    <p class="packing-list__carrier">
      Carrier:
      <span data-mc-preview="FedEx Freight"><span class="mc-packing-slip-liquid">{{ shipment.carrier }}</span></span>
      —
      <span data-mc-preview="Priority"><span class="mc-packing-slip-liquid">{{ shipment.method }}</span></span>
      · Cartons:
      <span data-mc-preview="7"><span class="mc-packing-slip-liquid">{{ shipment.cartons }}</span></span>
      · Weight:
      <span data-mc-preview="112 lb"><span class="mc-packing-slip-liquid">{{ shipment.weight }}</span></span>
    </p>

    <div>
      <span class="mc-packing-slip-liquid">{{ order.number | barcode }}</span>
      <div class="packing-list__barcode mc-packing-slip-preview-only">
        <div class="packing-list__barcode-bars"></div>
        <span class="packing-list__barcode-label">ORD-88912</span>
      </div>
    </div>

    <p class="packing-list__footer">Received by: ______________________ &nbsp;&nbsp; Date: ____________</p>
  </main>
</body>
</html>`,
}

const normalizePackingSlipStarterLabel = (label: string): string =>
  label.trim().toLowerCase()

/** Built-in B2B starter first; drop API rows that duplicate the built-in id or label. */
export const mergePackingSlipDefaultTemplatesWithBuiltIn = (
  apiTemplates: NormalizedPackingSlipDefaultTemplate[]
): NormalizedPackingSlipDefaultTemplate[] => {
  const builtInLabel = normalizePackingSlipStarterLabel(
    REFERENCE_B2B_PACKING_SLIP_STARTER.label
  )

  const filtered = apiTemplates.filter((template) => {
    if (template.id === REFERENCE_B2B_PACKING_SLIP_STARTER.id) {
      return false
    }

    if (normalizePackingSlipStarterLabel(template.label) === builtInLabel) {
      return false
    }

    return true
  })

  return [REFERENCE_B2B_PACKING_SLIP_STARTER, ...filtered]
}

/** Always use the in-app built-in HTML for the B2B starter id (not a stale copy from API state). */
export const resolvePackingSlipStarterTemplateHtml = (
  template: NormalizedPackingSlipDefaultTemplate
): string => {
  if (template.id === REFERENCE_B2B_PACKING_SLIP_STARTER.id) {
    return REFERENCE_B2B_PACKING_SLIP_STARTER.html
  }

  return template.html
}
